import React from 'react';

import { openModal } from 'store/modals/actions';

import { reasonToModal } from 'modals/CancellationReasonModal/constants';

import { useCancelSubscription, useDispatch, useModals } from 'hooks';

import CancellationReasonModal from 'modals/CancellationReasonModal';

const CancellationReasonModalContainer = () => {
  const dispatch = useDispatch();
  const { closeModal } = useModals();

  const { discardCancellation, onCancelSubscription } = useCancelSubscription();

  const onSubmit = (reason: string) => {
    dispatch(openModal(reasonToModal[reason], { onError: onCancelSubscription }));
  };

  const handleClose = () => {
    closeModal();
    discardCancellation();
  };

  return <CancellationReasonModal onSubmit={onSubmit} onClose={handleClose} onCancel={onCancelSubscription} />;
};

export default CancellationReasonModalContainer;
